function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 79.893,
  y: 81.322,
  width: 59.374,
  height: 59.337
}), React.createElement("rect", {
  x: 274.652,
  y: 391.915,
  width: 59.337,
  height: 59.374
}), React.createElement("rect", {
  x: 452.672,
  y: 332.569,
  width: 59.337,
  height: 59.337
}), React.createElement("polygon", {
  points: "393.289,332.569 333.989,332.569 333.989,273.26 274.652,273.26 274.652,332.597 333.989,332.597  333.989,391.906 393.326,391.906 393.326,332.597 452.645,332.597 452.645,273.26 393.289,273.26  "
}), React.createElement("rect", {
  x: 393.289,
  y: 451.243,
  width: 59.355,
  height: 59.355
}), React.createElement("path", {
  d: "M17.139,220.589h184.89c9.461,0,17.13-7.669,17.139-17.13V18.55c0-9.47-7.669-17.139-17.139-17.139H17.139 C7.669,1.411,0,9.08,0,18.55v184.909C0,212.92,7.669,220.589,17.139,220.589z M34.269,35.68H184.89v150.64H34.269V35.68z"
}), React.createElement("rect", {
  x: 352.261,
  y: 81.322,
  width: 59.337,
  height: 59.337
}), React.createElement("path", {
  d: "M289.47,220.589h184.928c9.461,0,17.13-7.669,17.139-17.13V18.55c0-9.47-7.669-17.139-17.139-17.139H289.47 c-9.47,0-17.139,7.669-17.139,17.139v184.9C272.331,212.92,280,220.589,289.47,220.589z M306.6,35.68h150.659v150.64H306.6V35.68 z"
}), React.createElement("rect", {
  x: 80.292,
  y: 353.255,
  width: 59.337,
  height: 59.337
}), React.createElement("path", {
  d: "M202.429,273.325H17.501c-9.47,0-17.139,7.669-17.139,17.139v184.909c0,9.47,7.669,17.139,17.139,17.139h184.928 c9.461,0,17.13-7.678,17.139-17.139V290.464C219.568,280.994,211.899,273.325,202.429,273.325z M185.29,458.234H34.631V307.603 H185.29V458.234z"
}))));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgQrCode = function SvgQrCode(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.009 512.009",
    style: {
      enableBackground: "new 0 0 512.009 512.009"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgQrCode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/qr-code.1add2449.svg";
export { ForwardRef as ReactComponent };